import ImageZoom from "../../commons/ImageZoom";

const Loreal = () => {
  return (
    <div className="portfolio">
      <header className="portfolio-header">
        <p className="portfolio-kicker">Événement live</p>
        <h1>Gala L&apos;Oréal</h1>
        <p>
          Application web immersive pour un gala prestigieux — check-in,
          avatars, chat, votes et animations en temps réel.
        </p>
      </header>

      <section className="portfolio-section">
        <h2>Fonctionnalités</h2>
        <div className="portfolio-projects">
          <div className="project">
            <ImageZoom
              style={{ height: "200px", width: "auto", objectFit: "cover" }}
              alt="Chat en ligne du gala"
              src="./assets/loreal-chat.jpg"
            />
            <h3>Chat en ligne</h3>
            <p>
              Messages des invités rediffusés sur un écran géant, avec
              modération en direct.
            </p>
          </div>
          <div className="project">
            <ImageZoom
              style={{ height: "200px", width: "auto", objectFit: "cover" }}
              alt="Création d'avatars"
              src="./assets/loreal-avatar.jpg"
            />
            <h3>Création d&apos;avatars</h3>
            <p>
              Avatars personnalisés via Ready Player Me, visibles à côté de
              chaque message dans le chat.
            </p>
          </div>
          <div className="project">
            <ImageZoom
              style={{ height: "200px", width: "auto", objectFit: "cover" }}
              alt="Borne d'authentification"
              src="./assets/loreal-borne.jpg"
            />
            <h3>Bornes d&apos;authentification</h3>
            <p>
              Connexion via QR code depuis des bornes dans le hall d’entrée,
              pour un accès fluide à l’application.
            </p>
          </div>
        </div>
      </section>

      <section className="portfolio-section">
        <h2>À propos du projet</h2>
        <p>
          Pour le gala L’Oréal, j’ai développé une application web complète :
          check-in des invités, création d’avatars, plan de tables interactif,
          chat en ligne, votes pour les animations et roue de hasard.
        </p>
        <p>
          Les hôtesses disposaient d’un tableau de bord sur iPad pour suivre
          l’affluence et assister les participants. Notifications en temps
          réel, programme et moments clés complétaient l’expérience — pour une
          soirée plus fluide et participative.
        </p>
        <img
          style={{ maxWidth: "280px" }}
          src="./assets/loreal.png"
          alt="Logo L'Oréal"
          className="about-image"
        />
      </section>

      <footer className="portfolio-footer">
        <a href="mailto:julien.j.1999@hotmail.com">
          Contactez-moi : julien.j.1999@hotmail.com
        </a>
      </footer>
    </div>
  );
};

export default Loreal;
